import React, { useState, useEffect } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableRow, Paper, TableHead, Button, TablePagination, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import AddProcesos from './AddProcesos';
import Swal from 'sweetalert2';
import { useUser } from '../contexts/UserContext';
import { useAccesos } from '../contexts/AccesosContext';
function GestionProcesos() {
    const { tienePermiso } = useAccesos();
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [procesos, setProcesos] = useState([]);
    const [editingProceso, setEditingProceso] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [openDialog, setOpenDialog] = useState(false);
    const [procesoToDelete, setProcesoToDelete] = useState(null);
    const { user } = useUser();

    // Función para cargar los procesos
    const fetchProcesos = async () => {
        try {
            const response = await fetch(`${server}/MgProcesoes`);
            const data = await response.json();
            setProcesos(data.$values);
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Error al cargar los procesos: ' + error,
            });
        }
    };
    
    // Use effect para cargar los procesos al montar el componente
    useEffect(() => {
        fetchProcesos();
    }, []);

    // Actualiza la lista de procesos tras una modificación
    const handleNewProcesos = () => {
        fetchProcesos();
        setEditingProceso(null);
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleOpenDialog = (proceso) => {
        setProcesoToDelete(proceso);
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setProcesoToDelete(null);
    };

    const handleDeleteProceso = async () => {
        if (procesoToDelete) {
            try {
                const username = ''+user.codigoUsuario+'/';
                const response = await fetch(`${server}/MgProcesoes/${procesoToDelete.id}/${username}`, {
                    method: 'DELETE'
                });
                if (response.ok) {
                    handleCloseDialog();
                    fetchProcesos();
                    Swal.fire({
                        icon: 'success',
                        title: 'Éxito',
                        text: 'Proceso eliminado con éxito',
                    });
                } else {
                    handleCloseDialog();

                    const errorData = await response.json();
                    const errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                    Swal.fire({
                        icon: 'error',
                        title: `Error ${response.status}`,
                        text: errorMessage,
                    });                }
            } catch (error) {
         
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Error al eliminar el proceso: ' + error,
                });
            }
        }
    };

    const filteredProcesos = procesos.filter(proceso => proceso.descripcion.toLowerCase().includes(searchQuery.toLowerCase()));



    return (
        <>
            <div className="x_title">

            </div>
            <div className="x_content">

                <br />
                <AddProcesos handleNewProcesos={handleNewProcesos} editingProceso={editingProceso} />
                <div className="ln_solid" />

                <h2>Procesos Existentes</h2>
                <div className="row">
                    <div className="col-md-7 col-sm-4 offset-md-2">
                        <TextField
                            variant="outlined"
                            label="Buscar proceso"
                            fullWidth
                            value={searchQuery}
                            onChange={handleSearchChange}
                            style={{ marginBottom: '20px' }}
                        />
                        <div className="table-responsive">
                            <TableContainer component={Paper}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Código</TableCell>
                                            <TableCell>Descripción</TableCell>
                                            <TableCell>Empresa</TableCell>
                                            <TableCell align="right">Acciones</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {filteredProcesos.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((proceso) => (
                                            <TableRow key={proceso.id}>
                                                <TableCell>{proceso.codigo}</TableCell>
                                                <TableCell>{proceso.descripcion}</TableCell>
                                                <TableCell>{proceso.nombreEmpresa}</TableCell>
                                                <TableCell align="right">
                                                    <Button onClick={() => setEditingProceso(proceso)} color="primary" disabled={!tienePermiso('Editar Proceso')}>Editar</Button>
                                                    <Button onClick={() => handleOpenDialog(proceso)} color="secondary" disabled={!tienePermiso('Eliminar Proceso')}>Eliminar</Button>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25]}
                                    component="div"
                                    count={filteredProcesos.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                    labelRowsPerPage="Filas por página:"
                                    labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`}
                                />
                            </TableContainer>
                            <Dialog
                                open={openDialog}
                                onClose={handleCloseDialog}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                            >
                                <DialogTitle id="alert-dialog-title">{"Confirmar eliminación"}</DialogTitle>
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        ¿Estás seguro de que deseas eliminar el proceso seleccionado?
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={handleCloseDialog} color="primary">Cancelar</Button>
                                    <Button onClick={handleDeleteProceso} color="primary" autoFocus>Eliminar</Button>
                                </DialogActions>
                            </Dialog>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default GestionProcesos